"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewMasterSecretCommand = void 0;
const AbstractCommand_1 = require("../AbstractCommand");
class RenewMasterSecretCommand extends AbstractCommand_1.AbstractCommand {
    constructor(api, appId) {
        super(api);
        this.appId = appId;
    }
    async exec() {
        return (await this.api.put(`/applications/${this.appId}/reset`)).data;
    }
}
exports.RenewMasterSecretCommand = RenewMasterSecretCommand;
//# sourceMappingURL=RenewMasterSecretCommand.js.map